import { useTranslation } from 'react-i18next';

import { getSpokenLanguages } from '@/components/Popup/EditProfile/EditSpokenLanguagesPopup.tsx';
import { CandidateProfileApi } from '@/api/matchmaker/types.ts';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { tagStyle } from '@/components/UserProfile/styles.ts';

type LanguagesInfoBlockProps = {
  profile_data?: CandidateProfileApi;
};

export const LanguagesInfoBlock = ({
  profile_data
}: LanguagesInfoBlockProps) => {
  const { t } = useTranslation();
  const spokenLanguages = getSpokenLanguages(t);

  const languages = profile_data?.spoken_languages || [];

  if (languages.length === 0) return null;

  return (
    <InputContent
      title={t('spoken_languages_title')}
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px'
        }}
      >
        {languages.map((lang, index) => (
          <div key={index} style={tagStyle}>
            {spokenLanguages[lang]}
          </div>
        ))}
      </div>
    </InputContent>
  );
};
